import React from "react";
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Tooltip } from "recharts";

export default function TrustRadar({ criteria = [], height = 320 }) {
  const data = criteria.map((c) => ({ criterion: shortLabel(c.name), score: c.score, fullName: c.name }));
  return (
    <div style={{ width: "100%", height }} data-testid="trust-radar-chart">
      <ResponsiveContainer width="100%" height="100%">
        <RadarChart data={data} outerRadius="72%">
          <PolarGrid stroke="#D1CFC7" />
          <PolarAngleAxis dataKey="criterion" tick={{ fill: "#5C6B61", fontSize: 11 }} />
          <PolarRadiusAxis angle={30} domain={[0, 100]} tick={{ fill: "#8A998F", fontSize: 10 }} />
          <Radar name="Score" dataKey="score" stroke="#2A3B32" fill="#2A3B32" fillOpacity={0.15} strokeWidth={2} />
          <Tooltip
            contentStyle={{ background: "#FFFFFF", border: "1px solid #E5E3DB", borderRadius: 8, fontSize: 12 }}
            formatter={(value, _n, props) => [`${value}/100`, props?.payload?.fullName]}
          />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}

function shortLabel(name) {
  const map = {
    "Clinical Quality": "Clinical",
    "Patient Experience": "Experience",
    "Digital Maturity": "Digital",
    "AI Readiness": "AI",
    "Safety Standards": "Safety",
    "Governance": "Governance",
    "Continuing Education": "CME",
    "Accessibility": "Access",
    "Research Contributions": "Research",
    "Ethical Practices": "Ethics",
    "Sustainability": "ESG",
  };
  return map[name] || name;
}
